export default "/images/file-evictions.png";